export const INITIAL_WIDTH = 50;
export const INITIAL_HEIGHT = 50;

export function constructSnippet(
  width: number = INITIAL_WIDTH,
  height: number = INITIAL_HEIGHT
) {
  return `\
.container {
  display: grid;
  place-content: center;
}
\n\
.element {
  width: ${width}%;
  height: ${height}%;
}`;
}
